import React, { Fragment, ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../types/state/root.types';

import './spinner.scss';

const Spinner = (): ReactElement => {
  const spinners: string[] = useSelector((state: RootState): string[] => state.system.spinners);

  if (!spinners || spinners.length === 0) return <Fragment />;

  return (
    <div className="spinner">
      <p>{spinners.at(-1)}...</p>
      <div className="spinner__ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Spinner;
